<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="todo" slot-scope="prop">
        <el-checkbox label="待我处理" name="type" v-model="prop.form.todo" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {
  getAddressOptions,
} from '@qx/utils';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orderTypeOptions: [], // 订单类型
        auditSourceOptions: [], // 审核来源
        orgIdOptions: [],
        form: [
          { // 待我处理
            label: '待我处理',
            value: 'todo',
            default: true,
            slot: true,
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderIds',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 发车时间
            label: '发车时间',
            value: 'DependTime',
            type: 'date',
            placeholder: '请选择发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 审核来源
            label: '审核来源',
            value: 'auditSource',
            type: 'select',
            default: -1,
            placeholder: '请选择审核来源',
          },
          { // 客户名称
            label: '客户名称',
            value: 'customName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          {
            label: '运输起始位置',
            value: 'sourceRegion',
            type: 'cascader',
            clearable: true,
            options: getAddressOptions(),
          },
          {
            label: '运输终点位置',
            value: 'desRegion',
            type: 'cascader',
            clearable: true,
            default: [],
            options: getAddressOptions(),
          },
          { // 订单类型
            label: '订单类型',
            value: 'orderType',
            type: 'select',
            default: -1,
            placeholder: '请选择订单类型',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: [],
            placeholder: '请选择归属部门',
          },
          { // 录入人员
            label: '录入人员',
            value: 'opName',
            type: 'input',
            placeholder: '请输入录入人员',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 发车时间
      if (searchBoxData.DependTime && searchBoxData.DependTime.length > 0) {
        searchBoxData.beginDependTime = this.formatDate(searchBoxData.DependTime[0]);
        searchBoxData.endDependTime = this.formatDate(searchBoxData.DependTime[1]);
        delete searchBoxData.DependTime;
      }
      // 处理时间
      if (searchBoxData.ProblemDealTime && searchBoxData.ProblemDealTime.length > 0) {
        searchBoxData.beginProblemDealTime = this.formatDate(searchBoxData.ProblemDealTime[0]);
        searchBoxData.endProblemDealTime = this.formatDate(searchBoxData.ProblemDealTime[1]);
        delete searchBoxData.ProblemDealTime;
      }
      searchBoxData.sourceRegion = searchBoxData.sourceRegion[1];
      searchBoxData.desRegion = searchBoxData.desRegion[1];
      this.$refs.tableBox.saveSearchBoxData({
        priceEnum: -1,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'ORDER_TYPE,AUDIT_SOURCE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.orderTypeOptions = [ // 订单类型
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.auditSourceOptions = [ // 审核来源
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(1),
    ];
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
